// @flow
import { combineReducers } from 'redux';

import songlist from './songlist';
import song from './song';
// import blankSong from '../blankSong';
import ui from './ui';

// const getFirstFilename = () => {
//   const j = JSON.parse(localStorage.getItem('songs') || '[]');
//   if (j.length > 0) {
//     return j[0];
//   }
//   return null;
// };

// const getSong = (filename) => {
//   if (filename && filename.length > 0) {
//     const t = localStorage.getItem(filename);
//     if (t) return JSON.parse(t);
//   }
//   return null;
// };

// const getDefaultSong = () => {
//   const filename = getFirstFilename();
//   if (filename) {
//     const song = getSong(filename);
//     if (song) {
//       return Object.assign({}, song, {
//         filename,
//       });
//     }
//   }
//   return Object.assign({}, blankSong, {
//     filename: 'song1',
//   });
// };

// export function getDefaultSongs() {
//   return JSON.parse(localStorage.getItem('songs') || '[]');
// }

// function overall(state, action) {
//   return state;
// }

const reducers = {
  song,
  songlist,
  ui,
};

export type ReducersType = typeof reducers;

// const combined = combineReducers({
//   song,
//   songs,
//   ui
// });

// const defaultState = {
//   // song: getDefaultSong(),
//   songs: getDefaultSongs(),
// }

// const songBuilderApp = (state = defaultState, action) => {
//   return overall(
//     combined(state, action),
//     action
//   );

// }

export default combineReducers(reducers);



// WEBPACK FOOTER //
// ./src/reducers/index.js